module.exports = __webpack_public_path__ + "img/BJT.137ba772.svg";